import { LoginModal } from "../pages/auth/LoginModal";
import { RegisterModal } from "../pages/register/RegisterModal";
import { useConditional } from "../core/hooks/useConditional";
import { logoff, useSession } from "../core/hooks/useSession";
import { go } from "../core/route/Route";
import { settings } from "../settings";
import { useChannel } from "../core/hooks/useChannel";
import { useCallback, useState } from "react";
import { Icon } from "../core/ui/icons";


export function AuthDetails(props: {

}) {

	const loginModal = useConditional(() => {
		return (
			<LoginModal
				onClose={loginModal.close}
			/>
		)
	});
	const registerModal = useConditional(() => {
		return (
			<RegisterModal
				onClose={registerModal.close}
			/>
		)
	});

	const session = useSession();

	let loginItems;
	if (session.isAuthenticated()) {
		loginItems = 
			<>
				<button className="transparent" onClick={() => {
					go("/dashboard/");
				}}>
					{session.authToken?.name}
				</button>

				<button className="transparent" onClick={() => {
					logoff();
					debugger;
					go("/");
				}}>Logoff</button>
			</>;
	} else {
		loginItems = 
			<>
				<button className="transparent" onClick={() => {
					registerModal.show({});
				}}>Register</button>
				<button className="transparent" onClick={() => {
					loginModal.show({});
				}}>Login</button>
			</>;
	}

	return (
			<div
				className="auth-details text-inverse"
			>
				{loginItems}

				{loginModal.render()}
				{registerModal.render()}
			</div>
	);
}